export default [
  {
    id: 25,
    version: '1.29.0',
    date: 'October 18, 2024',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Series and Movie Emotion Index module reenabled',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Resolved commas splitting columns with CSV and Excel exports',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 24,
    version: '1.28.0',
    date: 'December 20, 2023',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Movies Company ID Migration for Studio Data',
            items: []
          },
          {
            title:
              'Platform Attribution - Add Originating Language, Originating Country, and Genre String as columns in report export',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Affinity Tool - Export not retaining content type filter',
            items: []
          },
          {
            title:
              'Affinity Tool - Affinity AND queries with exclusion filter causing page to crash',
            items: []
          },
          {
            title:
              'Report Builder - Saved Segments not retaining titles when new segments are created',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 24,
    version: '1.27.1',
    date: 'October 2, 2023',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Looker API Upgrade',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Report Builder - Resolved Delta between Balanced Metrics on Report Builder and Benchmark Score Bar',
            items: []
          },
          {
            title:
              'Report Builder - Resolved Issue with Saved Report Sharable links missing text',
            items: []
          },
          {
            title:
              'Report Builder - Pivoting on Title causes query to include parent content ID as a dimension',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 23,
    version: '1.27.0',
    date: 'September 5, 2023',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title:
              'Age Gating - Removal of users aged 13-15 and creation of 16-17 age group',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Series Detail Page - Affinity Report - Resolved issue with content filtering on report export',
            items: []
          },
          {
            title:
              'Benchmarks - Resolved issue with genre filters in custom benchmarks',
            items: []
          },
          {
            title:
              'Saved Filters - Resolved issue with compatible filters being inactive',
            items: []
          },
          {
            title:
              'Actor Detail Page - Resolved issue with content filter not applying to overall vote count  ',
            items: []
          },
          {
            title:
              'Report Builder - Resolved labeling issue for balanced reports where Balanced was being labeled Yes',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 22,
    version: '1.26.3',
    date: 'August 15, 2023',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title:
              'Updated Completion Rate to Exclude Specials and Unaired Episodes',
            items: []
          },
          {
            title: 'Various Bug Fixes',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Report Builder - Resolved error with pivoted report exports',
            items: []
          },
          {
            title:
              'Anticipation Tracker - Fixed issue with query being triggered on page load',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 21,
    version: '1.26.2',
    date: 'June 28, 2023',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Looker API v4 Upgrade',
            items: []
          },
          {
            title: 'Talent detail page links to new TV Time People page',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Anticipation Tracker - Release Date Filter Not Allowing Future Date Selection for Custom Selection',
            items: []
          },
          {
            title:
              'Anticipation Tracker - Release Date and Report Date Custom Date Selection Broken',
            items: []
          },
          {
            title:
              'Anticipation Tracker - Negative date selection on line chart not allowing some combinations',
            items: []
          },
          {
            title:
              'Character Data - For show ID 412366, duplicated characters a appearing in title-level view, but not episodic view',
            items: []
          },
          {
            title:
              'Character Data - Correct role info for "Hannah in The Last Thing He Told Me"',
            items: []
          },
          {
            title: 'Binge Report - Correct Binge Report tool tip',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 20,
    version: '1.26.1',
    date: 'May 11, 2023',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'With the release of CVMi 1.26.1, we are implementing a number of incremental improvements to CVMi with a focus on usability improvements and bug fixes',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Multi-Language Search',
            items: []
          },
          {
            title: 'Filtering Improvements',
            items: []
          },
          {
            title: 'Platform attribution improvements',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Affinity Tool - Genre filter on output not working correctly',
            items: []
          },
          {
            title:
              'Affinity Tool - Editing a report date selection crashes page',
            items: []
          },
          {
            title:
              'Anticipation Tracker - Labeling for network or studio and release date is incorrect',
            items: []
          },
          {
            title:
              'Platform Attribution - Title select from platform -> title view dropping last selected title',
            items: []
          },
          {
            title:
              'Series and Movie Detail Page - Gender Index Module Export % Incorrect',
            items: []
          },
          {
            title:
              'Excludes Filtering - Text being retained in filter search after filter is selected',
            items: []
          },
          {
            title:
              'Excludes Filtering - Movie Ranker - Filters Crash and Disappear when refresh page with excludes applied',
            items: []
          },
          {
            title:
              "Excludes Filtering - Titles checkboxes aren't being checked when selected on page load",
            items: []
          },
          {
            title:
              'Tables - Long titles do not wrap / display well in tables on CVMi',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 19,
    version: '1.26.0',
    date: 'March 27, 2023',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.26.0 introduces the highly anticipated Platform Attribution Tool. This tool enables users to view cross-platform and/or cross-title platform attribution using a single reporting tool. The Platform Attribution Tool makes it easy to customize cross-platform and cross-title platform attribution through an intuitive user interface that follows the same querying pattern established in the Affinity tool and Anticipation Tracker.',
            items: []
          },
          {
            title:
              'Additional changes in CVMi 1.26.0 include; adding new genres to the genre filter option and resolving an issue with refreshing the Movie Ranker while an excludes filter is applied',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Platform Attribution Tool',
            items: []
          },
          {
            title: 'Updated Genre Filters',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Corrected an issue with refreshing the Movie Ranker while an excludes filter is applied',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 18,
    version: '1.25.0',
    date: 'January 12, 2023',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.25.0 introduces excludes functionality to the CVMi filtering paradigm. Excludes filtering has been applied across CVMi and can be used for both content and user filters. Tools such as the Anticipation Tracker have also been updated to allow for excludes filtering with the content and audience filters. Similarly, the Affinity tool has been updated to add excludes filtering to the audience filtering (age and country).',
            items: []
          },
          {
            title:
              'Additional changes in CVMi 1.25.0 include; adding viewers to the benchmark score bar on the Movie Detail Page and export support for the Audience Snapshot in the Affinity Tool.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Excludes filtering',
            items: []
          },
          {
            title:
              'Viewers metric added to the Movie Benchmark Scorebar on the Audeince tab of a Movie Detail Page',
            items: []
          },
          {
            title:
              'Export support for the Audeince Snapshot in the Affinity tool',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Character images missing from newly released titles',
            items: []
          },
          {
            title:
              'Corrected the percentage visualization for Followers and Viewers by Age on Series Detail Pages',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 15,
    version: '1.24.0',
    date: 'October 19, 2022',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.24.0 delivers a number of client requests and usability improvements to the platform. This is the first CVMi update under our new Data Products team structure.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Movie and Series Detail Page metadata enhancements',
            items: []
          },
          {
            title: 'Anticipation Tracker future release date support',
            items: []
          },
          {
            title:
              'Redirect link after login for users not actively logged into CVMi who open a shared link',
            items: []
          },
          {
            title: 'Added report description tool tips to CVMi homepage',
            items: []
          },
          {
            title:
              'Actor Detail Page Country Index module sort updated to be based on descending sample size',
            items: []
          },
          {
            title:
              'Redirect link after login for users not actively logged into CVMi who open a shared link',
            items: []
          },
          {
            title:
              'Added User Country and User Language Columns to the Series Detail Page Reaction module export',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 14,
    version: '1.21.0',
    date: 'March 10, 2022',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.21.0 introduces new styling to the Series and Movie Detail Pages through the creation of a new Affinity tab. The addition of the Affinity tab facilitates the relocation of the follower to viewer affinity module from the Anticipation tab and the viewer to viewer affinity module from the Audience tab to the new Affinity tab. The purpose of this update is to improve the efficiency of the system by grouping the affinity queries together. Functionally, there have been no changes to either affinity modules.',
            items: []
          },
          {
            title:
              "In addition to the new Affinity tab on the Series and Movie Detail Page, we are surfacing ‘Theatre' as a Where Are Viewers Watching voting option for movies. On February 5, 2022, the TV Time app deployed an updated in which it serves ‘Theatre’ as one of the default options in the Where Did You Watch prompt for movies. By surfacing “Theatre” as a default option, we are able to capture theatre viewership for titles actively playing in theaters and for users retroactively marking titles as viewed.",
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Affinity tab on Series and Movie Detail Pages',
            items: []
          },
          {
            title:
              'Theatre voting option for Where Are Viewers Watching module for movies',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 13,
    version: '1.20.0',
    date: 'October 28, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.20.0 includes an update to the Where Are Viewers Watching visualization and a number of key bug fixes. The update to the Where Are Viewers Watching module involves switching the data visualization from a logarithmically scaled bar chart to a simplified table. The purpose of this update is to simplify the Where Are Viewers Watching visualization and provide users with an easy to interpret visualization. Functionally, no changes were made to the module and CVMi users will be able to use the existing filters on the series and movie detail pages to refine the results of the Where Are Viewers Watching module.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: 'Where Are Viewers Watching visualization update',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Resolved an issue with Saved Reports with Network filters applied generating reports with no results',
            items: []
          },
          {
            title:
              'Resolved an issue where Series and Movies without a synopsis were causing the Series and Movie detail pages to crash',
            items: []
          },
          {
            title:
              'Resolved an issue with the Where Are Viewers Watching View Share percentage rounding incorrectly',
            items: []
          },
          {
            title:
              'Resolved a data issue where there were instances of Null platforms appearing in the Where are Viewers Watching Module',
            items: []
          },
          {
            title:
              'Resolved an issue with invalid user data on TVT causing distortions on the New and Total Followers visualizations',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 12,
    version: '1.18.0',
    date: 'August 31, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.180 introduces a number of highly anticipated updates to the platform. These updates include; the Where Did Viewers Watch (WDVW) module for series and movies, consolidated series and movie data for actors, and updates to series network metadata. The purpose of the Where Did Viewers Watch module is to display the first-party platform viewership voting data collected using the Where Did You Watch prompt on the TVTime app. CVMi users will be able to use the existing filters on the series and movie detail pages to refine the results of the Where Are Viewers Watching module.',
            items: []
          },
          {
            title:
              'We have updated the Actor Detail Page and the Actor Ranker to now display data for both series and movies. By Default, the Actor Ranker displays data for series and movies. Users can use the content filters to refine results by content type, network, and studio.',
            items: []
          },
          {
            title:
              'We have updated series network metadata field to enable CVMi users to track series based off of the most recent and relevant network. Previously, the network field on CVMi was determined by the network of the first episode of a series. We have updated the network field to populate based off of the network of the most recent episode. The network update extends across all of CVMi and will be reflected anywhere where the network of a series is displayed. ',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title:
              'Where Did Viewers Watch data available on Series and Movie Audience Detail Pages',
            items: []
          },
          {
            title: 'Actor Detail Page updated to include movies data',
            items: []
          },
          {
            title:
              'Network metadata field on series updated to populate based off of the network of the most recent episode',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Network detail page bug where page filters were not included in the initial page load has been resolved',
            items: []
          },
          {
            title:
              'Affinity module bug where saved segments were not selectable has been resolved ',
            items: []
          },
          {
            title:
              'Sample Balancing corrections on Series and Movie Age Index modules',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 11,
    version: '1.17.1',
    date: 'June 30, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'With the release of CVMi 1.17.1, we are implementing a number of incremental improvements to CVMi with a focus on bug fixes and performance improvements.',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'We have updated the Anticipation Tracker to facilitate international sample balancing. Previously, the module was experiencing a bug with sample balancing territories with exception to the United States.',
            items: []
          },
          {
            title:
              'We have resolved an issue on the Anticipated Shows page where the date filter was not functioning as intended.',
            items: []
          },
          {
            title:
              'The New Shows Anticipation table was also updated to prevent titles that are returning series from appearing in the New Shows table.',
            items: []
          },
          {
            title:
              'The Benchmark Scorebar on gated accounts has been updated to resolve a bug where the show or movie counter in the bottom right corner was showing results for all content. The intended functionality is to display the count of shows or movies for the relevant follower tier group.',
            items: []
          },
          {
            title:
              'The Report Builder was showing all content filtering options for accounts that were content gated. This issue has been resolved and gated users are now only shown filtering options that are aligned with the gating on their accounts.',
            items: []
          },
          {
            title:
              'We have made improvements to the Affinity Audience Snapshot in the backend which has helped improved the speed at which the module loads.',
            items: []
          },
          {
            title:
              'There was an issue with Top Performing Shows (Network detail page) to include both shows that have premiered and shows that have not yet premiered. This has been resolved to display only released content.',
            items: []
          },
          {
            title:
              'Resolved an issue with the Network filter selection where the Network filter was clearing when inputing more than 1 network.',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 10,
    version: '1.17.0',
    date: 'May 25, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.17.0 introduces All Title Affinity which enables users to understand overlapping viewership and affinity across all supported content types. Previously, affinity was siloed by content type (series or movies) and would provide the overlapping viewership and affinity index for an audience relative to a single or combination of titles that the audiences have viewed. The introduction of All Title Affinity gives users the ability to assess and understand affinity and overlapping viewership between both content types.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `All Title Affinity`,
            description: null,
            items: []
          },
          {
            title: `Sample Balancing tool tip`,
            description: null,
            items: []
          },
          {
            title: `Removal of Ranker: Monitor page`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Fixes to the ‘Days from Release’ field on Report Builder',
            items: []
          },
          {
            title:
              ' Sample Balancing corrections on Series and Movie Age Index modules',
            items: []
          },
          {
            title:
              'Segment functionality improved on series and movie detail pages',
            items: []
          },
          {
            title: 'Improved efficiency for the Moments Module',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 9,
    version: '1.16.0',
    date: 'April 6, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'CVMi 1.16.0 brings substantial improvements to movie data availability on CVMi. This includes, benchmarking on the movie detail page and updating the Report Builder to accommodate movie data. In addition to increasing the availability of movie data on CVMi, we have also expanded sample balancing support for all territories currently available in CVMi. This filter will now be applied by default across the application to make it easier to access more representative data.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `Movie benchmarking`,
            description: null,
            items: []
          },
          {
            title: `Updates to Report Builder to facilitate both movie and series data`,
            description: null,
            items: []
          },
          {
            title: `Updated sample balancing support for all CVMi territories`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            title:
              'Updated UI to Report Builder to facilitate series and movie data ',
            items: []
          },
          {
            title:
              'Bulk title search (series and movies) in the Segment Builder ',
            items: []
          },
          {
            title: 'Added additional filters to the Segment Builder',
            items: []
          },
          {
            title: 'Pivoted Tables are now exportable on Report Builder',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Refined sourcing and filter expression on csv and xlsx exports.',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 8,
    version: '1.15.1',
    date: 'March 16, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'With the release of CVMi 1.15.1, we are implementing a number of incremental improvements to CVMi including bug fixes and enhanced segment sharing and saving functionalities.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `In-Product System Status Alert`,
            description: null,
            items: []
          },
          {
            title: `Segment Sharing and Saving`,
            description: null,
            items: []
          },
          {
            title: `Hottest Character Module Export`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            title:
              "Users can now share a segment by sending a CVMi page link that has a saved segment applied. Additionally, users can save shared or manually applied segments by clicking on the 'save filters' button that appears next to the filter selection pills.",
            items: []
          },
          {
            title:
              'In an effort to bring all of the content detail CVMi pages to parity we have added the download functionality to the Hottest Character module on the Series and Movie Detail pages. ',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Null values in report builder replaced with ‘None’',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 7,
    version: '1.15.0',
    date: 'February 22, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'With the release of CVMi 1.15.0, we are presenting a more comprehensive set of emotions (12) to better capture audience sentiment. We have also developed and implemented indexed emotion vote modules on both show and movie detail pages to provide a more contextualized overview of user sentiment for any given piece of content.',
            items: []
          },
          {
            title:
              'The Moments module has also been updated and now features a toggle to allow analysis by Meme count or Engagement count. The height and color scale will reflect the metric selected in the toggle.',
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `New Emotions & Emotion Indexing`,
            description: null,
            items: []
          },
          {
            title: `Moments Design Update`,
            description: null,
            items: []
          },
          {
            title: `Updated Branding`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            title:
              'Updated overall and episodic emotion indexing modules on the series detail engagement page.',
            items: []
          },
          {
            title:
              'Updated overall emotion indexing on the movie detail engagement page.',
            items: []
          },
          {
            title:
              "Updates to the reaction module's user sentiment emotion filters to facilitate expansion to new 12 emotion set.",
            items: []
          },
          {
            title:
              'Updated moments module that allows for a toggle between two visualizations: meme count, engagement count',
            items: []
          },
          {
            title:
              'Report builder has been updated to facilitate the new 12 emotion set.',
            items: []
          },
          {
            title:
              'Updated branding across CVMi to align with new Whip Media logos and branding.',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Global search thresholds for series titles have been reduced to 100 followers.',
            items: []
          },
          {
            title: 'Added Networks: Discovery+, Paramount+',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 1,
    version: '1.14.0',
    date: 'January 15, 2021',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title:
              'With the release of CVMi 1.14.0, we are expanding on the sample balancing capabilities of the platform to include 5 new countries:',
            items: [
              {
                title: 'France',
                description: null
              },
              {
                title: 'Italy',
                description: null
              },
              {
                title: 'Germany',
                description: null
              },
              {
                title: 'Spain',
                description: null
              },
              {
                title: 'United Kingdom',
                description: null
              }
            ]
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `International Sample Balancing: France, Spain, UK, Italy, Germany`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            title:
              'International Sample Balancing: France, Spain, UK, Italy, Germany',
            items: [
              {
                description:
                  'Up until CVMi 1.14.0, sample balancing was only available for the United States. However, we have expanding sample balancing to include a number of key international markets starting with France, Spain, the UK, Italy, and Germany. We use industry standard sample balancing techniques to resolve modest demographic variances between the TV Time sample and the projected population, as reported by official government census data, by adjusting relative weights of individuals according to their demographic profile.'
              }
            ]
          },
          {
            title: 'Moments Module Update',
            items: [
              {
                description:
                  'The Moments module has been updated to set the y-axis as the engagement count and color density has been set to meme count. As a result, higher engagement moments will have taller bar charts and moments with a higher meme count will be greener whereas lower memed moments will be bluer.'
              }
            ]
          }
        ]
      },
      {
        title: 'Upcoming Updates',
        items: [
          {
            title: 'Emotions Index Updates',
            items: [
              {
                description:
                  'Expanding the votable emotions from 8 to 12 and mapping and indexing them to create indexed emotion values. Emotions are now indexed relative to other content that is of a similar genre(s) and will provide users with more contextualized data. '
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 2,
    version: '1.13.0',
    date: 'December 22, 2020',
    categories: [
      {
        title: 'Release Highlights',
        items: [
          {
            title: `Anticipation Tracker`,
            description: null,
            items: []
          },
          {
            title: `Reaction Module`,
            description: null,
            items: []
          },
          {
            title: `Improved metadata pipeline`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            html: {
              __html:
                "The <b>Anticipation Tracker</b> helps users monitor follower growth trends normalized to release day, enabling comparison of titles (movies and shows) regardless of release date.  This helps to answer questions such as 'How do follower growth rates compare to other network dramas released last season' or 'How does Queen's Gambit's growth rates compare to the Holidate on Netflix?'“. Note: This is an enhancement on the 'follower growth' report."
            },
            items: []
          },
          {
            html: {
              __html:
                'The <b>Reactions</b> module, located on the Engagement tab of both Movie and Series detail pages,  offers a rich view of audience commentary combined with engagement signals. It includes improved filtering functionality (page level filters (i.e. country, date), reaction type (image, meme, text), language, and audience sentiment, such as rating, emotion or character vote. '
            },
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title:
              'Improved metadata pipeline to address many metadata anomalies',
            items: []
          },
          {
            title: 'Misc export errors',
            items: []
          },
          {
            title:
              'Sticky filters generating multiple requests (fixed in 1.12.2)',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 3,
    version: '1.12.0',
    date: 'October 30, 2020',
    categories: [
      {
        title: 'Release Overview',
        items: [
          {
            title: `This release offers an enhanced “score bar” within each tab of the Show Detail page. This highlights a key attribute or performance indicator for a  particular dimension of a title (i.e. anticipation, audience, engagement). It allows users to define and apply customized benchmark segments to better compare and contextualize those key attributes and performance metrics. Ultimately, this functionality helps to answer questions such as “how is the health of anticipation around this title, and with whom is it resonating”, “Who is converting from followers to viewers and what more do we know about these audiences”.`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: 'Release Highlights',
        items: [
          {
            title: `Score bar featuring key attributes and performance indicators across Anticipation, Audience and Engagement. `,
            description: null,
            items: []
          },
          {
            title: `Customizable benchmark segments, defined by content attributes (i.e. genre, follower size, release date), demographics (i.e. age, gender, country) and date, and compared against target title attributes and performance metrics.`,
            description: null,
            items: []
          }
        ]
      },
      {
        title: "What's New",
        items: [
          {
            title: 'Show Detail - Score Bar Metrics',
            items: [
              {
                title: 'Anticipation',
                items: [
                  {
                    description:
                      'Total Followers - Measures total net users who are actively following a show.'
                  },
                  {
                    description:
                      'New Follower Trailing 7 Days - Measures net new followers over the last 7 completed days.'
                  },
                  {
                    description:
                      'Age Group Affinity - Represents highest follower indexing age bucket relative to the general app population.'
                  },
                  {
                    description:
                      'Gender Affinity - Represents highest follower indexing gender bucket relative to the general app population.'
                  }
                ]
              },
              {
                title: 'Audience',
                items: [
                  {
                    description:
                      'Follower Conversion Rate - Measures the percent of followers who have viewed at least one episode.'
                  },
                  {
                    description:
                      'Viewers - Measures total unique users who have tracked at least one episode of that title'
                  },
                  {
                    description:
                      'Age Group Affinity - Represents highest viewer indexing age bucket relative to the general app population.'
                  },
                  {
                    description:
                      'Gender Affinity - Represents highest viewer indexing gender bucket relative to the general app population.'
                  }
                ]
              },
              {
                title: 'Engagement',
                items: [
                  {
                    description:
                      'Completion Rate - Measures percent of available content viewed among show watchers.'
                  },
                  {
                    description:
                      'Engagement Score - Measures an audience’s engagement to an episode, season or series.  Engagement interactions are weighted depending on importance normalized relative to the episodes tracked.'
                  },
                  {
                    description:
                      'Binge Rate - Measures percent of viewers who watched for 4 or more episodes in a 24 hour period'
                  },
                  {
                    description:
                      'Rating - Measures average audience rating of all episodes within that series, based on a scale of 5. This is used to indicate overall quality or satisfaction with a piece of content'
                  }
                ]
              },
              {
                title:
                  'Percentage Difference - Measures the percentage difference between the target title and the benchmark segment. It is calculated as [(title# - benchmark#)/title#].',
                items: []
              }
            ]
          },
          {
            title: 'Custom Segments for KPI Benchmarking',
            items: [
              {
                title:
                  'The benchmark segment builder defines a custom benchmark segment to help contextualize the Score Bar attributes and performance metrics. Benchmark segments may be defined by the following:',
                items: [
                  {
                    description:
                      'Content attributes: Show (OR) Network, Genre, Status, Runtime, Originating Country, Release Date, Follower Tier'
                  },
                  {
                    description:
                      'User attributes: Age Range, Gender, Country, Panel (US Only)'
                  },
                  {
                    description: 'Date attributes: Date'
                  }
                ]
              },

              {
                title:
                  'Benchmark segments may be saved, set as default and shared via URL.',
                items: []
              },
              {
                title:
                  'Benchmark segment attributes and metrics are located at the bottom of the score bar.',
                items: []
              },
              {
                title: `“Similar Shows” default is set based on shows with similar “size” or follower count.`,
                items: []
              }
            ]
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Anticipation - Follower Growth - X Axis spacing',
            items: []
          },
          {
            title: 'Report Builder - crash on pivoted reports',
            items: []
          },
          {
            title: 'Report Builder - remove row limit on non-pivoted reports',
            items: []
          },
          {
            title:
              'Network Detail - update label and sorting on Network Top Performing Shows',
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 4,
    version: '1.11.0',
    date: 'September 11, 2020',
    categories: [
      {
        title: "What's New",
        items: [
          {
            title: 'Anticipation',
            items: [
              {
                description: 'Show Follower Demographics'
              },
              {
                description:
                  'Total Follower - Growth Rates added to hover states on Show/Movie Detail'
              },
              {
                description:
                  'Release Date Filter added to Anticipation Reports (New Show, Returning Show, Movie)'
              },
              {
                description: 'Days from First Air Date added to Report Builder'
              }
            ]
          },
          {
            title: 'Actors',
            items: [
              {
                description: 'Fan Demographics - Gender'
              },
              {
                description: 'Actor Ranker - Share of Votes'
              }
            ]
          },
          {
            title: 'Network',
            items: [
              {
                description: 'Network Viewer Demographics'
              }
            ]
          },
          {
            title: 'Engagement',
            items: [
              {
                description:
                  'Enhanced visualizations for Episode Emotion and Fan Favorites'
              }
            ]
          },
          {
            title: 'Local Content Analysis',
            items: [
              {
                description:
                  'Originating Country Filter added to Anticipation Reports(New Show, Returning Show, Movie), Affinity Reports (Show, Movie) , Ranker Reports (Show, Movie, Binge)'
              }
            ]
          },
          {
            title: 'Metric Enhancements',
            items: [
              {
                description: 'Vote count added to ‘How did you watch’ (Device)'
              },
              {
                description: "Vote count added to ‘Fan Favorites'"
              }
            ]
          },
          {
            title: 'Enhanced Visualizations',
            items: [
              {
                description:
                  'New visualization (i.e. audience demographics, tables, report builder)'
              },
              {
                description: 'Loading states'
              }
            ]
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Exports not including filter parameters in files',
            description: null,
            items: []
          },
          {
            title: 'Show detail episode filter returning incorrect values',
            description: null,
            items: []
          },
          {
            title: 'Ad blockers blocking embeds',
            description: null,
            items: []
          },
          {
            title:
              'Older shows not returning in Report builder when sorting by First Air Date',
            description: null,
            items: []
          }
        ]
      }
    ]
  },
  {
    id: 5,
    version: '1.10.0',
    date: 'July 24, 2020',
    categories: [
      {
        title: "What's New",
        items: [
          {
            title: 'Affinity Enhancements: ',
            description:
              'Provides clearer mechanism to define and evaluate audience and limit results based on content attributes. Features Audience Criteria builder and Audience Snapshot.',
            items: []
          },
          {
            title: '',
            description:
              'Export functionality includes filter parameters on Report Builders and all Affinity, Anticipation and Ranker reports.',
            items: []
          },
          {
            title: '',
            description:
              'Movies Insights available with release - Please contact your Account Representative for more information!',
            items: [
              {
                description:
                  'Movie Detail - Features anticipation, audience and engagement insights'
              },
              {
                description:
                  'Movie Ranker - Features key performance indicators, such as followers, viewers, ratings and engagements'
              },
              {
                description:
                  'Movie Anticipation - Features pre-release intent to view with followers and growth rates, dynamic content and audience filtering and historical look-back'
              },
              {
                description:
                  'Movie Affinity -  Features Content Affinity Indexes to measure the proximity between Movie audiences and the volume of Overlapping Audiences. Includes Affinity enhancements, such as Audience Builder and Snapshot listed above.  '
              }
            ]
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: []
      }
    ]
  },
  {
    id: 6,
    version: '1.9.0',
    date: 'June 26, 2020',
    categories: [
      {
        title: "What's New",
        items: [
          {
            title: 'TVLytics is now CVM Insights',
            description:
              'In support of the recent merger, TVLytics, now CVM Insights, is now more tightly integrated with Mediamorph’s suite of Content Value Management (CVM) offerings. Stay tuned for further integration between offerings in 2021!',
            items: []
          },
          {
            title: 'Restructured Navigation',
            description:
              'This includes a new home for Anticipation, Affinity, Rankers (i.e. Show Ranker, Binge), Help, Release Notes. ',
            items: []
          },
          {
            title: 'Homepage Refresh',
            description:
              'Restructured navigation in support of upcoming Movies release. This includes a new home for Anticipation, Affinity, Rankers (i.e. Show Ranker, Binge), Help, Release Notes. ',
            items: []
          },
          {
            title: 'Profile',
            description:
              'Offers a quick way to access Account details, such as name and password, as well as saved reports and segments.',
            items: []
          }
        ]
      },
      {
        title: 'Bug Fixes',
        items: [
          {
            title: 'Missing Actor name and picture on Actor Page',
            description: null,
            items: []
          },
          {
            title:
              'Country filter not being applied properly to Show Audience Country Index',
            description: null,
            items: []
          }
        ]
      }
    ]
  }
];
